'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cloneIcon = cloneIcon;

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function cloneIcon(icon) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!icon) {
    return null;
  }

  if (typeof icon === 'string') {
    throw new Error('String icon names are deprecated. Pass icons by importing them from react-spectrum/Icon/IconName and render as <IconName />.');
  }

  return _react2.default.cloneElement(icon, {
    className: (0, _classnames2.default)(opts.className, icon.props.className),
    size: icon.props.size || opts.size,
    'aria-label': opts['aria-label'] || null,
    'aria-hidden': opts['aria-hidden'] || true
  });
}